import { render, staticRenderFns } from "./TestErrorPage.vue?vue&type=template&id=2d23271d&"
import script from "./TestErrorPage.vue?vue&type=script&lang=js&"
export * from "./TestErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports